/**
 * Nom de fichier sûr pour un téléchargement fabriqué dans le navigateur.
 *
 * Les accents sont repliés sur leur lettre de base (« échantillon » →
 * « echantillon ») AVANT le nettoyage : remplacer directement tout ce qui n'est
 * pas ASCII mangerait la lettre avec son accent (« pages-chantillon »).
 *
 * @param {string} name      Le nom voulu, sans extension.
 * @param {string} fallback  Rendu si le nom se réduit à rien.
 */
export const safeFileName = (name, fallback = 'export') => {
  const slug = String(name ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^\w.-]+/g, '-')
    .replace(/^-+|-+$/g, '')
  return slug || fallback
}
